import { render, staticRenderFns } from "./handset.vue?vue&type=template&id=55dde812&scoped=true"
import script from "./handset.vue?vue&type=script&lang=js"
export * from "./handset.vue?vue&type=script&lang=js"
import style0 from "./handset.vue?vue&type=style&index=0&id=55dde812&prod&scoped=true&lang=css"
import style1 from "./handset.vue?vue&type=style&index=1&id=55dde812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dde812",
  null
  
)

export default component.exports